<template>
  <div>
    <div class="row pt-5 pb-5" v-if="amount > 0">
      <div class="col-1">
        <span>{{ amount }}%</span>
      </div>
      <div class="col-11">
        <md-progress-bar md-mode="determinate" :md-value="amount"></md-progress-bar>
      </div>
    </div>

    <form class enctype="multipart/form-data" @submit.prevent="uploadVideo">
      <fieldset>
        <div class="form-group">
          <label>Upload file</label>
          <input
            accept="video/mp4"
            class="form-control"
            v-validate="'required'"
            name="videoFile"
            type="file"
            ref="file"
            v-on:change="handleFileUpload()"
            :class="{ 'is-invalid': submitted && errors.has('videoFile') }"
          />
          <div
            v-if="submitted && errors.has('videoFile')"
            class="invalid-feedback"
          >{{ errors.first('videoFile') }}</div>
        </div>
        <md-button type="submit" class="btn-primary">Submit</md-button>
      </fieldset>
    </form>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    file: "",
    amount: 0,
    submitted: false
  }),
  methods: {
    uploadVideo() {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        if (valid) {
          var _this = this;
          var data = new FormData();
          data.append("file", this.file, this.file.name);
          axios
            .post(`${process.env.VUE_APP_API_URL}/api/videos`, data, {
              onUploadProgress: function(uploadEvent) {
                _this.amount = Math.round(
                  (uploadEvent.loaded / uploadEvent.total) * 100
                );
                //  console.log(_this.amount)
              }
            })
            .then(res => {
              this.$swal.fire({
                position: "center",
                type: "success",
                title: "Video has been uploaded.",
                showConfirmButton: false,
                timer: 1500
              });
              this.$router.push({
                name: "editVideo",
                params: { id: res.data._id }
              });
              this.submitted = false;
              this.amount = 0;
              this.$refs.file.value = null;
            }).catch(err => {
               this.$swal.fire({
                position: "center",
                type: "error",
                title: err.response.data.message,
                showConfirmButton: true,
              });
            });
        }
      });
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    }
  }
};
</script>


<style lang="scss" scoped>
.md-progress-bar {
  // margin: 24px;
}
</style>
